import React from "react";
import { Formik, Form, Field } from "formik";
import { Link } from "react-router-dom";
import useValidations from "./validations";
import AcceptenceModal from "./AcceptenceModal";

const DefaultForm = ({
  loading,
  postRegister,
  roles,
  mostrarPassword,
  setVroles,
  vroles,
}) => {
  const validations = useValidations();

  if (loading) {
    return (
      <div className="form form--login form--white form--bordered">
        <label className="login-label">CARGANDO</label>
      </div>
    );
  }

  return (
    <div className="form form--login form--white form--bordered">
      <Formik
        initialValues={{
          username: "",
          password: "",
          confirmPassword: "",
          role: vroles ?? "",
          fullName: "",
          telephone: "",
          email: "",
        }}
        validationSchema={validations}
        onSubmit={async (values, { setSubmitting, setFieldError }) => {
          setSubmitting(true);
          await postRegister(values, setFieldError)
          setSubmitting(false);
        }}
      >
        {({ errors, touched, isSubmitting, handleChange }) => {

          
          return (
            <Form>
              <div className="form__wrapper">
                <div className="form__title text-center">Regístrate</div>
  
                <div className="form__row row">
                  <div className="col-sm-12 col-md-8">
                    <label htmlFor="nombre">Nombre Completo</label>
                    <Field
                      type="text"
                      name="fullName"
                      id="fullName"
                      required
                    ></Field>
                    {errors.fullName && touched.fullName && (
                      <span className="form__validation form__validation--error">
                        {errors.fullName}
                      </span>
                    )}
                    <span className="form__validation"></span>
                  </div>
                  <div className="col-sm-12 col-md-4">
                    <label>Tipo de Perfil</label>
                    <Field
                      as="select"
                      name="role"
                      value={vroles}
                      onChange={(data) => {
                        setVroles(data.target.value);
                        handleChange(data);
                      }}
                    >
                      <option hidden value="">
                        Selecione un perfil
                      </option>
                      {roles.map((item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.desc}
                          </option>
                        );
                      })}
                      <option value="otro">Otro</option>
                    </Field>
                    {errors.role && touched.role && (
                      <span className="form__validation form__validation--error">
                        {errors.role}
                      </span>
                    )}
                  </div>
                </div>
  
                <div className="form__row row">
                  <div className="col-sm-12 col-md-12">
                    <label htmlFor="email">Correo Electrónico</label>
                    <Field type="email" name="email" id="email" required></Field>
                    {errors.email && touched.email && (
                      <span className="form__validation form__validation--error">
                        {errors.email}
                      </span>
                    )}
                    <span className="form__validation"></span>
                  </div>
                  <div className="col-sm-12 col-md-4"></div>
                </div>
  
                <div className="form__row row">
                  <div className="col-sm-12 col-md-12">
                    <label htmlFor="username">Usuario</label>
                    <Field
                      type="text"
                      name="username"
                      id="username"
                      required
                    ></Field>
                    {errors.username && touched.username && (
                      <span className="form__validation form__validation--error">
                        {errors.username}
                      </span>
                    )}
                  </div>
                </div>
  
                <div className="form__row row">
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="password">Contraseña</label>
                    <Field
                      type="password"
                      name="password"
                      id="password"
                      required
                    ></Field>
                    <i
                      className="fa fa-eye-slash password-icon"
                      onClick={mostrarPassword}
                    />
                    {errors.password && touched.password && (
                      <span className="form__validation form__validation--error">
                        {errors.password}
                      </span>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="confirmPassword">Confirmar Contraseña</label>
                    <Field
                      type="password"
                      name="confirmPassword"
                      id="confirmPassword"
                      required
                    ></Field>
                    {errors.confirmPassword && touched.confirmPassword && (
                      <span className="form__validation form__validation--error">
                        {errors.confirmPassword}
                      </span>
                    )}
                  </div>
                </div>
  
                <div className="form_row row">
                  <div className="col-sm-12">
                    <label htmlFor="telephone">Teléfono</label>
                    <Field type="tel" name="telephone" id="telephone"></Field>
                    {errors.telephone && touched.telephone && (
                      <span className="form__validation form__validation--error">
                        {errors.telephone}
                      </span>
                    )}
                  </div>
                </div>
  
                {vroles === "applicant" ? (
                  <div className="form_row row">
                    <div className="col-12 ">
                      <Field
                        type="checkbox"
                        name="acceptence"
                        id="acceptence"
                        required
                      />
  
                      {errors.acceptence && (
                        <span className="form__validation form__validation--error">
                          {errors.acceptence}
                        </span>
                      )}
  
                      <div className="d-flex">
                        <p>Aceptar términos y condiciones</p>
                        <AcceptenceModal />
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
  
                <div className="form__row">
                  <button
                    type="submit"
                    className="btn btn--gradient btn__icon btn__icon--door !bg-gradient-to-r from-[#9100ff] to-[#4b00ff]"
                    disabled={isSubmitting}
                  >
                    Regístrate
                  </button>
                </div>
  
                <div className="form__row form__footer row">
                  <div className="col-8 col-md-6">
                    <Field
                      type="checkbox"
                      name="rememberpw"
                      id="rememberpw"
                    ></Field>
                    <label htmlFor="rememberpw">Recordar mi contraseña</label>
                  </div>
                  <div className="col-4 col-md-6 text-end">
                    ¿Ya eres usuario?{" "}
                    <Link to="/Login" className="link">
                      Accede
                    </Link>
                  </div>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  );
};

export default DefaultForm;
